import React from 'react'

import { FONT_FAMILY, PADDING } from '../constants'

export default function Median({
  scaleX,
  scaleY,
  fill,
  value,
  strokeWidth,
  strokeDasharray
}) {
  if (value == null) {
    // Do not render if there is no value
    return null
  }

  const [y1, y2] = scaleY.range()
  const [x1, x2] = scaleX.range()

  // If the median line is greater than a threshold, align the label to the right
  let threshold = (x2 - x1) * 0.5
  let position = scaleX(value)
  let offset = position > threshold ? -PADDING : PADDING
  let anchor = position > threshold ? 'end' : 'start'

  return (
    <g fontFamily={FONT_FAMILY} fill="#44a">
      <line
        x1={position}
        x2={position}
        y1={y1}
        y2={y2}
        stroke="#44f"
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        strokeOpacity="0.5"
      />

      <text
        x={position + offset}
        y={y1 - PADDING * 2}
        textAnchor={anchor}
        fillOpacity="0.8"
        dominantBaseline="central"
      >
        Median Valuation
      </text>
    </g>
  )
}

Median.defaultProps = {
  strokeWidth: 1,
  strokeDasharray: '2 5'
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/median.js